import React from 'react';

import { Autocomplete } from '@mui/material';
import { styled } from '@mui/system';

const StyledAutocomplete = styled(Autocomplete)({
  '& .MuiOutlinedInput-root': {
    height: '32px !important',
    backgroundColor: 'white',
    padding: '0 !important',
    '& fieldset': {
      border: '0.5px solid var(--du-color-grey)',
    },
    '&:hover': {
      backgroundColor: 'var(--du-color-grey-pale)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--du-color-grey)',
    },
    '&:disabled fieldset': {
      color: 'var(--du-color-grey)',
      border: '0.5px solid var(--du-color-grey)',
      backgroundColor: 'var(--du-color-grey-light)',
    },
    '&.Mui-focused fieldset': {
      boxShadow: '0px 0px 8px var(--du-color-black-shadow)',
      border: '0.5px solid var(--du-color-grey)',
    },
    '& .Mui-focused': {
      backgroundColor: 'white',
    },
  },
  '& .MuiAutocomplete-option[aria-selected="true"]': {
    color: 'var(--du-color-primary) !important',
    backgroundColor: 'transparent !important',
  },
  '& .MuiAutocomplete-input': {
    padding: '0 10px !important',
  },
});

export default StyledAutocomplete;
